// @mui
import {
  Grid,
  Card,
  Button,
  CardHeader,
  Typography,
  Stack,
  Box,
  CardContent,
  LinearProgress,
} from "@mui/material";

// routes
import { PATH_DASHBOARD } from "../../routes/paths";
// components
import Iconify from "../../components/Iconify";
import OrderedProduct from "./OrderedProduct";
import HeaderBreadcrumbs from "src/components/HeaderBreadcrumbs";
import { useQuery } from "react-query";
import { ordersSingleOrder } from "../api";
import EmptyContent from "src/components/EmptyContent";
import EmptyCart from "../../assets/images/empty-cart.png";
import ShippingAddressInfo from "./ShippingAddressInfo";
import { formatAsINR } from "src/sections/@dashboard/general/analytics/AnalyticsTrafficBySite";
import { useNavigate } from "react-router-dom";

export default function ViewProduct({
  onClose,
  row,
  selectedSchool,
  isGlobal,
}) {
  const navigate = useNavigate();
  const { data, isLoading } = useQuery({
    queryKey: ["ordersSingleOrder", row?.orderID],
    queryFn: ordersSingleOrder,
    enabled: !!row?.orderID,
  });

  return (
    <>
      {!isGlobal && (
        <HeaderBreadcrumbs
          heading={`Order#${row?.orderID}`}
          links={[
            { name: "Dashboard", href: PATH_DASHBOARD.root },
            {
              name: "School-Order",
            },
            { name: "Order-Detail" },
          ]}
        />
      )}
      <Button
        color="inherit"
        onClick={onClose}
        startIcon={<Iconify icon={"eva:arrow-ios-back-fill"} />}
        sx={{ mb: 2 }}
      >
        Back to Order List
      </Button>
      <Button
        color="primary"
        onClick={() => {
          navigate('/dashboard/invoice', { state: { ...row, vendorId: data?.[0]?.deliveryNShipping?.vendorId } });
        }}
        endIcon={<Iconify icon={'lets-icons:view'} />}
        sx={{ mb: 2 ,ml:2}}
        variant="outlined"
      >
        View Order Detail
      </Button>

      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <Card sx={{ mb: 3 }}>
            <CardHeader
              title={
                <Typography variant="h6">
                  Details
                  <Typography
                    component="span"
                    sx={{ color: "text.secondary" }}
                  ></Typography>
                </Typography>
              }
            />
            <CardContent>
              {isLoading && <LinearProgress />}
              {data && data[0].products?.length > 0 ? (
                <>
                  <OrderedProduct
                    products={data[0]?.products || []}
                    row={selectedSchool}
                  />

                  <Stack spacing={2} alignItems={"flex-end"} sx={{ mt: 2 }}>
                    <Stack direction="row">
                      <Typography
                        variant="body2"
                        sx={{ color: "text.secondary" }}
                      >
                        Sub Total
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        sx={{ width: "160px", textAlign: "right" }}
                      >
                        {formatAsINR(
                          data[0]?.products?.reduce(
                            (acc, crr) => acc + crr.amount,
                            0
                          ) || 0
                        )}
                      </Typography>
                    </Stack>

                    <Stack direction="row">
                      <Typography
                        variant="body2"
                        sx={{ color: "text.secondary" }}
                      >
                        Shipping
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        sx={{ width: "160px", textAlign: "right" }}
                      >
                        {formatAsINR(data[0].deliveryNShipping.price || 0)}
                      </Typography>
                    </Stack>

                    {data[0]?.deliveryNShipping?.discountAmount > 0 && (
                      <Stack direction="row" alignItems="center">
                        <Typography
                          variant="body2"
                          sx={{ color: "text.secondary" }}
                        >
                          Discount
                          {data[0]?.deliveryNShipping?.promoName && (
                            <Typography
                              component="span"
                              variant="caption"
                              sx={{
                                ml: 0.5,
                                px: 0.8,
                                py: 0.2,
                                borderRadius: "4px",
                                background: "rgba(84,214,44,0.16)",
                                color: "success.dark",
                                fontWeight: "bold",
                                letterSpacing: "0.5px",
                              }}
                            >
                              {data[0].deliveryNShipping.promoName}
                            </Typography>
                          )}
                        </Typography>
                        <Typography
                          variant="subtitle2"
                          sx={{ width: "160px", textAlign: "right", color: "success.main" }}
                        >
                          -{formatAsINR(data[0].deliveryNShipping.discountAmount)}
                        </Typography>
                      </Stack>
                    )}

                    <Stack direction="row" justifyContent="space-between">
                      <Typography variant="subtitle1">Total</Typography>
                      <Box sx={{ textAlign: "right", width: "160px" }}>
                        <Typography
                          variant="subtitle1"
                          sx={{ color: "error.main" }}
                        >
                          {formatAsINR(data[0]?.paymentDetails?.amount || 0)}
                        </Typography>
                      </Box>
                    </Stack>
                  </Stack>
                </>
              ) : (
                <EmptyContent
                  title="No Record to Display!"
                  // description="Look like you have no items in your shopping cart."
                  img={EmptyCart}
                />
              )}
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={4}>
          <ShippingAddressInfo
            row={row}
            shipingdetail={data && data[0]?.deliveryNShipping}
            paymetInfo={data && data[0]?.paymentDetails}
          />
        </Grid>
      </Grid>
    </>
  );
}
